import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import AuthTopBar from './AuthTopBar'

interface Props {
  children: ReactNode
  /** Classe aplicada ao contentor de página inteira (ex: fundo do registo). */
  outerClassName?: string
  /** Classe aplicada ao Container do cartão (ex: opacidade do cartão de registo). */
  containerClassName?: string
}

/** Estrutura partilhada das páginas públicas: barra de topo fixa em cima e o
 *  cartão centrado no espaço restante. */
export default function AuthLayout({ children, outerClassName, containerClassName }: Props) {
  return (
    <Box
      className={outerClassName}
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <AuthTopBar />
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          alignItems: { xs: 'flex-start', sm: 'center' },
          pt: { xs: 3, sm: 4 },
          // Margem inferior + safe-area (barra de gestos/endereço do browser
          // em iOS/Android e em PWA instalada).
          pb: {
            xs: 'calc(24px + env(safe-area-inset-bottom, 0px))',
            sm: 'calc(32px + env(safe-area-inset-bottom, 0px))',
          },
          px: 2,
        }}
      >
        <Container maxWidth="xs" disableGutters className={containerClassName}>
          {children}
        </Container>
      </Box>
    </Box>
  )
}
